const country = [
  {
    key: "BD",
    value: "Bangladesh",
    Iso3: "BGD",
    Unicode: "🇧🇩",
    Dial: "880",
    Currency: "BDT",
    Capital: "Dhaka",
    Continent: "AS"
  },
  {
    key: "BE",
    value: "Belgium",
    Iso3: "BEL",
    Unicode: "🇧🇪",
    Dial: "32",
    Currency: "EUR",
    Capital: "Brussels",
    Continent: "EU"
  },
  {
    key: "BF",
    value: "Burkina Faso",
    Iso3: "BFA",
    Unicode: "🇧🇫",
    Dial: "226",
    Currency: "XOF",
    Capital: "Ouagadougou",
    Continent: "AF"
  },
  {
    key: "BG",
    value: "Bulgaria",
    Iso3: "BGR",
    Unicode: "🇧🇬",
    Dial: "359",
    Currency: "BGN",
    Capital: "Sofia",
    Continent: "EU"
  },
  {
    key: "BA",
    value: "Bosnia and Herzegovina",
    Iso3: "BIH",
    Unicode: "🇧🇦",
    Dial: "387",
    Currency: "BAM",
    Capital: "Sarajevo",
    Continent: "EU"
  },
  {
    key: "BB",
    value: "Barbados",
    Iso3: "BRB",
    Unicode: "🇧🇧",
    Dial: "+1-246",
    Currency: "BBD",
    Capital: "Bridgetown",
    Continent: "NA"
  },
  {
    key: "WF",
    value: "Wallis and Futuna",
    Iso3: "WLF",
    Unicode: "🇼🇫",
    Dial: "681",
    Currency: "XPF",
    Capital: "Mata Utu",
    Continent: "OC"
  },
  {
    key: "BL",
    value: "Saint Barthelemy",
    Iso3: "BLM",
    Unicode: "🇧🇱",
    Dial: "590",
    Currency: "EUR",
    Capital: "Gustavia",
    Continent: "NA"
  },
  {
    key: "BM",
    value: "Bermuda",
    Iso3: "BMU",
    Unicode: "🇧🇲",
    Dial: "+1-441",
    Currency: "BMD",
    Capital: "Hamilton",
    Continent: "NA"
  },
  {
    key: "BN",
    value: "Brunei",
    Iso3: "BRN",
    Unicode: "🇧🇳",
    Dial: "673",
    Currency: "BND",
    Capital: "Bandar Seri Begawan",
    Continent: "AS"
  },
  {
    key: "BO",
    value: "Bolivia",
    Iso3: "BOL",
    Unicode: "🇧🇴",
    Dial: "591",
    Currency: "BOB",
    Capital: "Sucre",
    Continent: "SA"
  },
  {
    key: "BH",
    value: "Bahrain",
    Iso3: "BHR",
    Unicode: "🇧🇭",
    Dial: "973",
    Currency: "BHD",
    Capital: "Manama",
    Continent: "AS"
  },
  {
    key: "BI",
    value: "Burundi",
    Iso3: "BDI",
    Unicode: "🇧🇮",
    Dial: "257",
    Currency: "BIF",
    Capital: "Bujumbura",
    Continent: "AF"
  },
  {
    key: "BJ",
    value: "Benin",
    Iso3: "BEN",
    Unicode: "🇧🇯",
    Dial: "229",
    Currency: "XOF",
    Capital: "Porto-Novo",
    Continent: "AF"
  },
  {
    key: "BT",
    value: "Bhutan",
    Iso3: "BTN",
    Unicode: "🇧🇹",
    Dial: "975",
    Currency: "BTN",
    Capital: "Thimphu",
    Continent: "AS"
  },
  {
    key: "JM",
    value: "Jamaica",
    Iso3: "JAM",
    Unicode: "🇯🇲",
    Dial: "+1-876",
    Currency: "JMD",
    Capital: "Kingston",
    Continent: "NA"
  },
  {
    key: "BV",
    value: "Bouvet Island",
    Iso3: "BVT",
    Unicode: "🇧🇻",
    Dial: "",
    Currency: "NOK",
    Capital: "",
    Continent: "AN"
  },
  {
    key: "BW",
    value: "Botswana",
    Iso3: "BWA",
    Unicode: "🇧🇼",
    Dial: "267",
    Currency: "BWP",
    Capital: "Gaborone",
    Continent: "AF"
  },
  {
    key: "WS",
    value: "Samoa",
    Iso3: "WSM",
    Unicode: "🇼🇸",
    Dial: "685",
    Currency: "WST",
    Capital: "Apia",
    Continent: "OC"
  },
  {
    key: "BQ",
    value: "Bonaire, Saint Eustatius and Saba ",
    Iso3: "BES",
    Unicode: "🇧🇶",
    Dial: "599",
    Currency: "USD",
    Capital: "",
    Continent: "NA"
  },
  {
    key: "BR",
    value: "Brazil",
    Iso3: "BRA",
    Unicode: "🇧🇷",
    Dial: "55",
    Currency: "BRL",
    Capital: "Brasilia",
    Continent: "SA"
  },
  {
    key: "BS",
    value: "Bahamas",
    Iso3: "BHS",
    Unicode: "🇧🇸",
    Dial: "+1-242",
    Currency: "BSD",
    Capital: "Nassau",
    Continent: "NA"
  },
  {
    key: "JE",
    value: "Jersey",
    Iso3: "JEY",
    Unicode: "🇯🇪",
    Dial: "+44-1534",
    Currency: "GBP",
    Capital: "Saint Helier",
    Continent: "EU"
  },
  {
    key: "BY",
    value: "Belarus",
    Iso3: "BLR",
    Unicode: "🇧🇾",
    Dial: "375",
    Currency: "BYR",
    Capital: "Minsk",
    Continent: "EU"
  },
  {
    key: "BZ",
    value: "Belize",
    Iso3: "BLZ",
    Unicode: "🇧🇿",
    Dial: "501",
    Currency: "BZD",
    Capital: "Belmopan",
    Continent: "NA"
  },
  {
    key: "RU",
    value: "Russia",
    Iso3: "RUS",
    Unicode: "🇷🇺",
    Dial: "7",
    Currency: "RUB",
    Capital: "Moscow",
    Continent: "EU"
  },
  {
    key: "RW",
    value: "Rwanda",
    Iso3: "RWA",
    Unicode: "🇷🇼",
    Dial: "250",
    Currency: "RWF",
    Capital: "Kigali",
    Continent: "AF"
  },
  {
    key: "RS",
    value: "Serbia",
    Iso3: "SRB",
    Unicode: "🇷🇸",
    Dial: "381",
    Currency: "RSD",
    Capital: "Belgrade",
    Continent: "EU"
  },
  {
    key: "TL",
    value: "East Timor",
    Iso3: "TLS",
    Unicode: "🇹🇱",
    Dial: "670",
    Currency: "USD",
    Capital: "Dili",
    Continent: "OC"
  },
  {
    key: "RE",
    value: "Reunion",
    Iso3: "REU",
    Unicode: "🇷🇪",
    Dial: "262",
    Currency: "EUR",
    Capital: "Saint-Denis",
    Continent: "AF"
  },
  {
    key: "TM",
    value: "Turkmenistan",
    Iso3: "TKM",
    Unicode: "🇹🇲",
    Dial: "993",
    Currency: "TMT",
    Capital: "Ashgabat",
    Continent: "AS"
  },
  {
    key: "TJ",
    value: "Tajikistan",
    Iso3: "TJK",
    Unicode: "🇹🇯",
    Dial: "992",
    Currency: "TJS",
    Capital: "Dushanbe",
    Continent: "AS"
  },
  {
    key: "RO",
    value: "Romania",
    Iso3: "ROU",
    Unicode: "🇷🇴",
    Dial: "40",
    Currency: "RON",
    Capital: "Bucharest",
    Continent: "EU"
  },
  {
    key: "TK",
    value: "Tokelau",
    Iso3: "TKL",
    Unicode: "🇹🇰",
    Dial: "690",
    Currency: "NZD",
    Capital: "",
    Continent: "OC"
  },
  {
    key: "GW",
    value: "Guinea-Bissau",
    Iso3: "GNB",
    Unicode: "🇬🇼",
    Dial: "245",
    Currency: "XOF",
    Capital: "Bissau",
    Continent: "AF"
  },
  {
    key: "GU",
    value: "Guam",
    Iso3: "GUM",
    Unicode: "🇬🇺",
    Dial: "+1-671",
    Currency: "USD",
    Capital: "Hagatna",
    Continent: "OC"
  },
  {
    key: "GT",
    value: "Guatemala",
    Iso3: "GTM",
    Unicode: "🇬🇹",
    Dial: "502",
    Currency: "GTQ",
    Capital: "Guatemala City",
    Continent: "NA"
  },
  {
    key: "GS",
    value: "South Georgia and the South Sandwich Islands",
    Iso3: "SGS",
    Unicode: "🇬🇸",
    Dial: "",
    Currency: "GBP",
    Capital: "Grytviken",
    Continent: "AN"
  },
  {
    key: "GR",
    value: "Greece",
    Iso3: "GRC",
    Unicode: "🇬🇷",
    Dial: "30",
    Currency: "EUR",
    Capital: "Athens",
    Continent: "EU"
  },
  {
    key: "GQ",
    value: "Equatorial Guinea",
    Iso3: "GNQ",
    Unicode: "🇬🇶",
    Dial: "240",
    Currency: "XAF",
    Capital: "Malabo",
    Continent: "AF"
  },
  {
    key: "GP",
    value: "Guadeloupe",
    Iso3: "GLP",
    Unicode: "🇬🇵",
    Dial: "590",
    Currency: "EUR",
    Capital: "Basse-Terre",
    Continent: "NA"
  },
  {
    key: "JP",
    value: "Japan",
    Iso3: "JPN",
    Unicode: "🇯🇵",
    Dial: "81",
    Currency: "JPY",
    Capital: "Tokyo",
    Continent: "AS"
  },
  {
    key: "GY",
    value: "Guyana",
    Iso3: "GUY",
    Unicode: "🇬🇾",
    Dial: "592",
    Currency: "GYD",
    Capital: "Georgetown",
    Continent: "SA"
  },
  {
    key: "GG",
    value: "Guernsey",
    Iso3: "GGY",
    Unicode: "🇬🇬",
    Dial: "+44-1481",
    Currency: "GBP",
    Capital: "St Peter Port",
    Continent: "EU"
  },
  {
    key: "GF",
    value: "French Guiana",
    Iso3: "GUF",
    Unicode: "🇬🇫",
    Dial: "594",
    Currency: "EUR",
    Capital: "Cayenne",
    Continent: "SA"
  },
  {
    key: "GE",
    value: "Georgia",
    Iso3: "GEO",
    Unicode: "🇬🇪",
    Dial: "995",
    Currency: "GEL",
    Capital: "Tbilisi",
    Continent: "AS"
  },
  {
    key: "GD",
    value: "Grenada",
    Iso3: "GRD",
    Unicode: "🇬🇩",
    Dial: "+1-473",
    Currency: "XCD",
    Capital: "St. George's",
    Continent: "NA"
  },
  {
    key: "GB",
    value: "United Kingdom",
    Iso3: "GBR",
    Unicode: "🇬🇧",
    Dial: "44",
    Currency: "GBP",
    Capital: "London",
    Continent: "EU"
  },
  {
    key: "GA",
    value: "Gabon",
    Iso3: "GAB",
    Unicode: "🇬🇦",
    Dial: "241",
    Currency: "XAF",
    Capital: "Libreville",
    Continent: "AF"
  },
  {
    key: "SV",
    value: "El Salvador",
    Iso3: "SLV",
    Unicode: "🇸🇻",
    Dial: "503",
    Currency: "USD",
    Capital: "San Salvador",
    Continent: "NA"
  },
  {
    key: "GN",
    value: "Guinea",
    Iso3: "GIN",
    Unicode: "🇬🇳",
    Dial: "224",
    Currency: "GNF",
    Capital: "Conakry",
    Continent: "AF"
  },
  {
    key: "GM",
    value: "Gambia",
    Iso3: "GMB",
    Unicode: "🇬🇲",
    Dial: "220",
    Currency: "GMD",
    Capital: "Banjul",
    Continent: "AF"
  },
  {
    key: "GL",
    value: "Greenland",
    Iso3: "GRL",
    Unicode: "🇬🇱",
    Dial: "299",
    Currency: "DKK",
    Capital: "Nuuk",
    Continent: "NA"
  },
  {
    key: "GI",
    value: "Gibraltar",
    Iso3: "GIB",
    Unicode: "🇬🇮",
    Dial: "350",
    Currency: "GIP",
    Capital: "Gibraltar",
    Continent: "EU"
  },
  {
    key: "GH",
    value: "Ghana",
    Iso3: "GHA",
    Unicode: "🇬🇭",
    Dial: "233",
    Currency: "GHS",
    Capital: "Accra",
    Continent: "AF"
  },
  {
    key: "OM",
    value: "Oman",
    Iso3: "OMN",
    Unicode: "🇴🇲",
    Dial: "968",
    Currency: "OMR",
    Capital: "Muscat",
    Continent: "AS"
  },
  {
    key: "TN",
    value: "Tunisia",
    Iso3: "TUN",
    Unicode: "🇹🇳",
    Dial: "216",
    Currency: "TND",
    Capital: "Tunis",
    Continent: "AF"
  },
  {
    key: "JO",
    value: "Jordan",
    Iso3: "JOR",
    Unicode: "🇯🇴",
    Dial: "962",
    Currency: "JOD",
    Capital: "Amman",
    Continent: "AS"
  },
  {
    key: "HR",
    value: "Croatia",
    Iso3: "HRV",
    Unicode: "🇭🇷",
    Dial: "385",
    Currency: "HRK",
    Capital: "Zagreb",
    Continent: "EU"
  },
  {
    key: "HT",
    value: "Haiti",
    Iso3: "HTI",
    Unicode: "🇭🇹",
    Dial: "509",
    Currency: "HTG",
    Capital: "Port-au-Prince",
    Continent: "NA"
  },
  {
    key: "HU",
    value: "Hungary",
    Iso3: "HUN",
    Unicode: "🇭🇺",
    Dial: "36",
    Currency: "HUF",
    Capital: "Budapest",
    Continent: "EU"
  },
  {
    key: "HK",
    value: "Hong Kong",
    Iso3: "HKG",
    Unicode: "🇭🇰",
    Dial: "852",
    Currency: "HKD",
    Capital: "Hong Kong",
    Continent: "AS"
  },
  {
    key: "HN",
    value: "Honduras",
    Iso3: "HND",
    Unicode: "🇭🇳",
    Dial: "504",
    Currency: "HNL",
    Capital: "Tegucigalpa",
    Continent: "NA"
  },
  {
    key: "HM",
    value: "Heard Island and McDonald Islands",
    Iso3: "HMD",
    Unicode: "🇭🇲",
    Dial: " ",
    Currency: "AUD",
    Capital: "",
    Continent: "AN"
  },
  {
    key: "VE",
    value: "Venezuela",
    Iso3: "VEN",
    Unicode: "🇻🇪",
    Dial: "58",
    Currency: "VEF",
    Capital: "Caracas",
    Continent: "SA"
  },
  {
    key: "PR",
    value: "Puerto Rico",
    Iso3: "PRI",
    Unicode: "🇵🇷",
    Dial: "+1-787 and 1-939",
    Currency: "USD",
    Capital: "San Juan",
    Continent: "NA"
  },
  {
    key: "PS",
    value: "Palestinian Territory",
    Iso3: "PSE",
    Unicode: "🇵🇸",
    Dial: "970",
    Currency: "ILS",
    Capital: "East Jerusalem",
    Continent: "AS"
  },
  {
    key: "PW",
    value: "Palau",
    Iso3: "PLW",
    Unicode: "🇵🇼",
    Dial: "680",
    Currency: "USD",
    Capital: "Melekeok",
    Continent: "OC"
  },
  {
    key: "PT",
    value: "Portugal",
    Iso3: "PRT",
    Unicode: "🇵🇹",
    Dial: "351",
    Currency: "EUR",
    Capital: "Lisbon",
    Continent: "EU"
  },
  {
    key: "SJ",
    value: "Svalbard and Jan Mayen",
    Iso3: "SJM",
    Unicode: "🇸🇯",
    Dial: "47",
    Currency: "NOK",
    Capital: "Longyearbyen",
    Continent: "EU"
  },
  {
    key: "PY",
    value: "Paraguay",
    Iso3: "PRY",
    Unicode: "🇵🇾",
    Dial: "595",
    Currency: "PYG",
    Capital: "Asuncion",
    Continent: "SA"
  },
  {
    key: "IQ",
    value: "Iraq",
    Iso3: "IRQ",
    Unicode: "🇮🇶",
    Dial: "964",
    Currency: "IQD",
    Capital: "Baghdad",
    Continent: "AS"
  },
  {
    key: "PA",
    value: "Panama",
    Iso3: "PAN",
    Unicode: "🇵🇦",
    Dial: "507",
    Currency: "PAB",
    Capital: "Panama City",
    Continent: "NA"
  },
  {
    key: "PF",
    value: "French Polynesia",
    Iso3: "PYF",
    Unicode: "🇵🇫",
    Dial: "689",
    Currency: "XPF",
    Capital: "Papeete",
    Continent: "OC"
  },
  {
    key: "PG",
    value: "Papua New Guinea",
    Iso3: "PNG",
    Unicode: "🇵🇬",
    Dial: "675",
    Currency: "PGK",
    Capital: "Port Moresby",
    Continent: "OC"
  },
  {
    key: "PE",
    value: "Peru",
    Iso3: "PER",
    Unicode: "🇵🇪",
    Dial: "51",
    Currency: "PEN",
    Capital: "Lima",
    Continent: "SA"
  },
  {
    key: "PK",
    value: "Pakistan",
    Iso3: "PAK",
    Unicode: "🇵🇰",
    Dial: "92",
    Currency: "PKR",
    Capital: "Islamabad",
    Continent: "AS"
  },
  {
    key: "PH",
    value: "Philippines",
    Iso3: "PHL",
    Unicode: "🇵🇭",
    Dial: "63",
    Currency: "PHP",
    Capital: "Manila",
    Continent: "AS"
  },
  {
    key: "PN",
    value: "Pitcairn",
    Iso3: "PCN",
    Unicode: "🇵🇳",
    Dial: "870",
    Currency: "NZD",
    Capital: "Adamstown",
    Continent: "OC"
  },
  {
    key: "PL",
    value: "Poland",
    Iso3: "POL",
    Unicode: "🇵🇱",
    Dial: "48",
    Currency: "PLN",
    Capital: "Warsaw",
    Continent: "EU"
  },
  {
    key: "PM",
    value: "Saint Pierre and Miquelon",
    Iso3: "SPM",
    Unicode: "🇵🇲",
    Dial: "508",
    Currency: "EUR",
    Capital: "Saint-Pierre",
    Continent: "NA"
  },
  {
    key: "ZM",
    value: "Zambia",
    Iso3: "ZMB",
    Unicode: "🇿🇲",
    Dial: "260",
    Currency: "ZMK",
    Capital: "Lusaka",
    Continent: "AF"
  },
  {
    key: "EH",
    value: "Western Sahara",
    Iso3: "ESH",
    Unicode: "🇪🇭",
    Dial: "212",
    Currency: "MAD",
    Capital: "El-Aaiun",
    Continent: "AF"
  },
  {
    key: "EE",
    value: "Estonia",
    Iso3: "EST",
    Unicode: "🇪🇪",
    Dial: "372",
    Currency: "EUR",
    Capital: "Tallinn",
    Continent: "EU"
  },
  {
    key: "EG",
    value: "Egypt",
    Iso3: "EGY",
    Unicode: "🇪🇬",
    Dial: "20",
    Currency: "EGP",
    Capital: "Cairo",
    Continent: "AF"
  },
  {
    key: "ZA",
    value: "South Africa",
    Iso3: "ZAF",
    Unicode: "🇿🇦",
    Dial: "27",
    Currency: "ZAR",
    Capital: "Pretoria",
    Continent: "AF"
  },
  {
    key: "EC",
    value: "Ecuador",
    Iso3: "ECU",
    Unicode: "🇪🇨",
    Dial: "593",
    Currency: "USD",
    Capital: "Quito",
    Continent: "SA"
  },
  {
    key: "IT",
    value: "Italy",
    Iso3: "ITA",
    Unicode: "🇮🇹",
    Dial: "39",
    Currency: "EUR",
    Capital: "Rome",
    Continent: "EU"
  },
  {
    key: "VN",
    value: "Vietnam",
    Iso3: "VNM",
    Unicode: "🇻🇳",
    Dial: "84",
    Currency: "VND",
    Capital: "Hanoi",
    Continent: "AS"
  },
  {
    key: "SB",
    value: "Solomon Islands",
    Iso3: "SLB",
    Unicode: "🇸🇧",
    Dial: "677",
    Currency: "SBD",
    Capital: "Honiara",
    Continent: "OC"
  },
  {
    key: "ET",
    value: "Ethiopia",
    Iso3: "ETH",
    Unicode: "🇪🇹",
    Dial: "251",
    Currency: "ETB",
    Capital: "Addis Ababa",
    Continent: "AF"
  },
  {
    key: "SO",
    value: "Somalia",
    Iso3: "SOM",
    Unicode: "🇸🇴",
    Dial: "252",
    Currency: "SOS",
    Capital: "Mogadishu",
    Continent: "AF"
  },
  {
    key: "ZW",
    value: "Zimbabwe",
    Iso3: "ZWE",
    Unicode: "🇿🇼",
    Dial: "263",
    Currency: "ZWL",
    Capital: "Harare",
    Continent: "AF"
  },
  {
    key: "SA",
    value: "Saudi Arabia",
    Iso3: "SAU",
    Unicode: "🇸🇦",
    Dial: "966",
    Currency: "SAR",
    Capital: "Riyadh",
    Continent: "AS"
  },
  {
    key: "ES",
    value: "Spain",
    Iso3: "ESP",
    Unicode: "🇪🇸",
    Dial: "34",
    Currency: "EUR",
    Capital: "Madrid",
    Continent: "EU"
  },
  {
    key: "ER",
    value: "Eritrea",
    Iso3: "ERI",
    Unicode: "🇪🇷",
    Dial: "291",
    Currency: "ERN",
    Capital: "Asmara",
    Continent: "AF"
  },
  {
    key: "ME",
    value: "Montenegro",
    Iso3: "MNE",
    Unicode: "🇲🇪",
    Dial: "382",
    Currency: "EUR",
    Capital: "Podgorica",
    Continent: "EU"
  },
  {
    key: "MD",
    value: "Moldova",
    Iso3: "MDA",
    Unicode: "🇲🇩",
    Dial: "373",
    Currency: "MDL",
    Capital: "Chisinau",
    Continent: "EU"
  },
  {
    key: "MG",
    value: "Madagascar",
    Iso3: "MDG",
    Unicode: "🇲🇬",
    Dial: "261",
    Currency: "MGA",
    Capital: "Antananarivo",
    Continent: "AF"
  },
  {
    key: "MF",
    value: "Saint Martin",
    Iso3: "MAF",
    Unicode: "🇲🇫",
    Dial: "590",
    Currency: "EUR",
    Capital: "Marigot",
    Continent: "NA"
  },
  {
    key: "MA",
    value: "Morocco",
    Iso3: "MAR",
    Unicode: "🇲🇦",
    Dial: "212",
    Currency: "MAD",
    Capital: "Rabat",
    Continent: "AF"
  },
  {
    key: "MC",
    value: "Monaco",
    Iso3: "MCO",
    Unicode: "🇲🇨",
    Dial: "377",
    Currency: "EUR",
    Capital: "Monaco",
    Continent: "EU"
  },
  {
    key: "UZ",
    value: "Uzbekistan",
    Iso3: "UZB",
    Unicode: "🇺🇿",
    Dial: "998",
    Currency: "UZS",
    Capital: "Tashkent",
    Continent: "AS"
  },
  {
    key: "MM",
    value: "Myanmar",
    Iso3: "MMR",
    Unicode: "🇲🇲",
    Dial: "95",
    Currency: "MMK",
    Capital: "Nay Pyi Taw",
    Continent: "AS"
  },
  {
    key: "ML",
    value: "Mali",
    Iso3: "MLI",
    Unicode: "🇲🇱",
    Dial: "223",
    Currency: "XOF",
    Capital: "Bamako",
    Continent: "AF"
  },
  {
    key: "MO",
    value: "Macao",
    Iso3: "MAC",
    Unicode: "🇲🇴",
    Dial: "853",
    Currency: "MOP",
    Capital: "Macao",
    Continent: "AS"
  },
  {
    key: "MN",
    value: "Mongolia",
    Iso3: "MNG",
    Unicode: "🇲🇳",
    Dial: "976",
    Currency: "MNT",
    Capital: "Ulan Bator",
    Continent: "AS"
  },
  {
    key: "MH",
    value: "Marshall Islands",
    Iso3: "MHL",
    Unicode: "🇲🇭",
    Dial: "692",
    Currency: "USD",
    Capital: "Majuro",
    Continent: "OC"
  },
  {
    key: "MK",
    value: "Macedonia",
    Iso3: "MKD",
    Unicode: "🇲🇰",
    Dial: "389",
    Currency: "MKD",
    Capital: "Skopje",
    Continent: "EU"
  },
  {
    key: "MU",
    value: "Mauritius",
    Iso3: "MUS",
    Unicode: "🇲🇺",
    Dial: "230",
    Currency: "MUR",
    Capital: "Port Louis",
    Continent: "AF"
  },
  {
    key: "MT",
    value: "Malta",
    Iso3: "MLT",
    Unicode: "🇲🇹",
    Dial: "356",
    Currency: "EUR",
    Capital: "Valletta",
    Continent: "EU"
  },
  {
    key: "MW",
    value: "Malawi",
    Iso3: "MWI",
    Unicode: "🇲🇼",
    Dial: "265",
    Currency: "MWK",
    Capital: "Lilongwe",
    Continent: "AF"
  },
  {
    key: "MV",
    value: "Maldives",
    Iso3: "MDV",
    Unicode: "🇲🇻",
    Dial: "960",
    Currency: "MVR",
    Capital: "Male",
    Continent: "AS"
  },
  {
    key: "MQ",
    value: "Martinique",
    Iso3: "MTQ",
    Unicode: "🇲🇶",
    Dial: "596",
    Currency: "EUR",
    Capital: "Fort-fr-France",
    Continent: "NA"
  },
  {
    key: "MP",
    value: "Northern Mariana Islands",
    Iso3: "MNP",
    Unicode: "🇲🇵",
    Dial: "+1-670",
    Currency: "USD",
    Capital: "Saipan",
    Continent: "OC"
  },
  {
    key: "MS",
    value: "Montserrat",
    Iso3: "MSR",
    Unicode: "🇲🇸",
    Dial: "+1-664",
    Currency: "XCD",
    Capital: "Plymouth",
    Continent: "NA"
  },
  {
    key: "MR",
    value: "Mauritania",
    Iso3: "MRT",
    Unicode: "🇲🇷",
    Dial: "222",
    Currency: "MRO",
    Capital: "Nouakchott",
    Continent: "AF"
  },
  {
    key: "IM",
    value: "Isle of Man",
    Iso3: "IMN",
    Unicode: "🇮🇲",
    Dial: "+44-1624",
    Currency: "GBP",
    Capital: "Douglas, Isle of Man",
    Continent: "EU"
  },
  {
    key: "UG",
    value: "Uganda",
    Iso3: "UGA",
    Unicode: "🇺🇬",
    Dial: "256",
    Currency: "UGX",
    Capital: "Kampala",
    Continent: "AF"
  },
  {
    key: "TZ",
    value: "Tanzania",
    Iso3: "TZA",
    Unicode: "🇹🇿",
    Dial: "255",
    Currency: "TZS",
    Capital: "Dodoma",
    Continent: "AF"
  },
  {
    key: "MY",
    value: "Malaysia",
    Iso3: "MYS",
    Unicode: "🇲🇾",
    Dial: "60",
    Currency: "MYR",
    Capital: "Kuala Lumpur",
    Continent: "AS"
  },
  {
    key: "MX",
    value: "Mexico",
    Iso3: "MEX",
    Unicode: "🇲🇽",
    Dial: "52",
    Currency: "MXN",
    Capital: "Mexico City",
    Continent: "NA"
  },
  {
    key: "IL",
    value: "Israel",
    Iso3: "ISR",
    Unicode: "🇮🇱",
    Dial: "972",
    Currency: "ILS",
    Capital: "Jerusalem",
    Continent: "AS"
  },
  {
    key: "FR",
    value: "France",
    Iso3: "FRA",
    Unicode: "🇫🇷",
    Dial: "33",
    Currency: "EUR",
    Capital: "Paris",
    Continent: "EU"
  },
  {
    key: "IO",
    value: "British Indian Ocean Territory",
    Iso3: "IOT",
    Unicode: "🇮🇴",
    Dial: "246",
    Currency: "USD",
    Capital: "Diego Garcia",
    Continent: "AS"
  },
  {
    key: "SH",
    value: "Saint Helena",
    Iso3: "SHN",
    Unicode: "🇸🇭",
    Dial: "290",
    Currency: "SHP",
    Capital: "Jamestown",
    Continent: "AF"
  },
  {
    key: "FI",
    value: "Finland",
    Iso3: "FIN",
    Unicode: "🇫🇮",
    Dial: "358",
    Currency: "EUR",
    Capital: "Helsinki",
    Continent: "EU"
  },
  {
    key: "FJ",
    value: "Fiji",
    Iso3: "FJI",
    Unicode: "🇫🇯",
    Dial: "679",
    Currency: "FJD",
    Capital: "Suva",
    Continent: "OC"
  },
  {
    key: "FK",
    value: "Falkland Islands",
    Iso3: "FLK",
    Unicode: "🇫🇰",
    Dial: "500",
    Currency: "FKP",
    Capital: "Stanley",
    Continent: "SA"
  },
  {
    key: "FM",
    value: "Micronesia",
    Iso3: "FSM",
    Unicode: "🇫🇲",
    Dial: "691",
    Currency: "USD",
    Capital: "Palikir",
    Continent: "OC"
  },
  {
    key: "FO",
    value: "Faroe Islands",
    Iso3: "FRO",
    Unicode: "🇫🇴",
    Dial: "298",
    Currency: "DKK",
    Capital: "Torshavn",
    Continent: "EU"
  },
  {
    key: "NI",
    value: "Nicaragua",
    Iso3: "NIC",
    Unicode: "🇳🇮",
    Dial: "505",
    Currency: "NIO",
    Capital: "Managua",
    Continent: "NA"
  },
  {
    key: "NL",
    value: "Netherlands",
    Iso3: "NLD",
    Unicode: "🇳🇱",
    Dial: "31",
    Currency: "EUR",
    Capital: "Amsterdam",
    Continent: "EU"
  },
  {
    key: "NO",
    value: "Norway",
    Iso3: "NOR",
    Unicode: "🇳🇴",
    Dial: "47",
    Currency: "NOK",
    Capital: "Oslo",
    Continent: "EU"
  },
  {
    key: "NA",
    value: "Namibia",
    Iso3: "NAM",
    Unicode: "🇳🇦",
    Dial: "264",
    Currency: "NAD",
    Capital: "Windhoek",
    Continent: "AF"
  },
  {
    key: "VU",
    value: "Vanuatu",
    Iso3: "VUT",
    Unicode: "🇻🇺",
    Dial: "678",
    Currency: "VUV",
    Capital: "Port Vila",
    Continent: "OC"
  },
  {
    key: "NC",
    value: "New Caledonia",
    Iso3: "NCL",
    Unicode: "🇳🇨",
    Dial: "687",
    Currency: "XPF",
    Capital: "Noumea",
    Continent: "OC"
  },
  {
    key: "NE",
    value: "Niger",
    Iso3: "NER",
    Unicode: "🇳🇪",
    Dial: "227",
    Currency: "XOF",
    Capital: "Niamey",
    Continent: "AF"
  },
  {
    key: "NF",
    value: "Norfolk Island",
    Iso3: "NFK",
    Unicode: "🇳🇫",
    Dial: "672",
    Currency: "AUD",
    Capital: "Kingston",
    Continent: "OC"
  },
  {
    key: "NG",
    value: "Nigeria",
    Iso3: "NGA",
    Unicode: "🇳🇬",
    Dial: "234",
    Currency: "NGN",
    Capital: "Abuja",
    Continent: "AF"
  },
  {
    key: "NZ",
    value: "New Zealand",
    Iso3: "NZL",
    Unicode: "🇳🇿",
    Dial: "64",
    Currency: "NZD",
    Capital: "Wellington",
    Continent: "OC"
  },
  {
    key: "NP",
    value: "Nepal",
    Iso3: "NPL",
    Unicode: "🇳🇵",
    Dial: "977",
    Currency: "NPR",
    Capital: "Kathmandu",
    Continent: "AS"
  },
  {
    key: "NR",
    value: "Nauru",
    Iso3: "NRU",
    Unicode: "🇳🇷",
    Dial: "674",
    Currency: "AUD",
    Capital: "Yaren",
    Continent: "OC"
  },
  {
    key: "NU",
    value: "Niue",
    Iso3: "NIU",
    Unicode: "🇳🇺",
    Dial: "683",
    Currency: "NZD",
    Capital: "Alofi",
    Continent: "OC"
  },
  {
    key: "CK",
    value: "Cook Islands",
    Iso3: "COK",
    Unicode: "🇨🇰",
    Dial: "682",
    Currency: "NZD",
    Capital: "Avarua",
    Continent: "OC"
  },
  {
    key: "XK",
    value: "Kosovo",
    Iso3: "XKX",
    Unicode: "🇽🇰",
    Dial: "",
    Currency: "EUR",
    Capital: "Pristina",
    Continent: "EU"
  },
  {
    key: "CI",
    value: "Ivory Coast",
    Iso3: "CIV",
    Unicode: "🇨🇮",
    Dial: "225",
    Currency: "XOF",
    Capital: "Yamoussoukro",
    Continent: "AF"
  },
  {
    key: "CH",
    value: "Switzerland",
    Iso3: "CHE",
    Unicode: "🇨🇭",
    Dial: "41",
    Currency: "CHF",
    Capital: "Berne",
    Continent: "EU"
  },
  {
    key: "CO",
    value: "Colombia",
    Iso3: "COL",
    Unicode: "🇨🇴",
    Dial: "57",
    Currency: "COP",
    Capital: "Bogota",
    Continent: "SA"
  },
  {
    key: "CN",
    value: "China",
    Iso3: "CHN",
    Unicode: "🇨🇳",
    Dial: "86",
    Currency: "CNY",
    Capital: "Beijing",
    Continent: "AS"
  },
  {
    key: "CM",
    value: "Cameroon",
    Iso3: "CMR",
    Unicode: "🇨🇲",
    Dial: "237",
    Currency: "XAF",
    Capital: "Yaounde",
    Continent: "AF"
  },
  {
    key: "CL",
    value: "Chile",
    Iso3: "CHL",
    Unicode: "🇨🇱",
    Dial: "56",
    Currency: "CLP",
    Capital: "Santiago",
    Continent: "SA"
  },
  {
    key: "CC",
    value: "Cocos Islands",
    Iso3: "CCK",
    Unicode: "🇨🇨",
    Dial: "61",
    Currency: "AUD",
    Capital: "West Island",
    Continent: "AS"
  },
  {
    key: "CA",
    value: "Canada",
    Iso3: "CAN",
    Unicode: "🇨🇦",
    Dial: "1",
    Currency: "CAD",
    Capital: "Ottawa",
    Continent: "NA"
  },
  {
    key: "CG",
    value: "Republic of the Congo",
    Iso3: "COG",
    Unicode: "🇨🇬",
    Dial: "242",
    Currency: "XAF",
    Capital: "Brazzaville",
    Continent: "AF"
  },
  {
    key: "CF",
    value: "Central African Republic",
    Iso3: "CAF",
    Unicode: "🇨🇫",
    Dial: "236",
    Currency: "XAF",
    Capital: "Bangui",
    Continent: "AF"
  },
  {
    key: "CD",
    value: "Democratic Republic of the Congo",
    Iso3: "COD",
    Unicode: "🇨🇩",
    Dial: "243",
    Currency: "CDF",
    Capital: "Kinshasa",
    Continent: "AF"
  },
  {
    key: "CZ",
    value: "Czech Republic",
    Iso3: "CZE",
    Unicode: "🇨🇿",
    Dial: "420",
    Currency: "CZK",
    Capital: "Prague",
    Continent: "EU"
  },
  {
    key: "CY",
    value: "Cyprus",
    Iso3: "CYP",
    Unicode: "🇨🇾",
    Dial: "357",
    Currency: "EUR",
    Capital: "Nicosia",
    Continent: "EU"
  },
  {
    key: "CX",
    value: "Christmas Island",
    Iso3: "CXR",
    Unicode: "🇨🇽",
    Dial: "61",
    Currency: "AUD",
    Capital: "Flying Fish Cove",
    Continent: "AS"
  },
  {
    key: "CR",
    value: "Costa Rica",
    Iso3: "CRI",
    Unicode: "🇨🇷",
    Dial: "506",
    Currency: "CRC",
    Capital: "San Jose",
    Continent: "NA"
  },
  {
    key: "CW",
    value: "Curacao",
    Iso3: "CUW",
    Unicode: "🇨🇼",
    Dial: "599",
    Currency: "ANG",
    Capital: " Willemstad",
    Continent: "NA"
  },
  {
    key: "CV",
    value: "Cape Verde",
    Iso3: "CPV",
    Unicode: "🇨🇻",
    Dial: "238",
    Currency: "CVE",
    Capital: "Praia",
    Continent: "AF"
  },
  {
    key: "CU",
    value: "Cuba",
    Iso3: "CUB",
    Unicode: "🇨🇺",
    Dial: "53",
    Currency: "CUP",
    Capital: "Havana",
    Continent: "NA"
  },
  {
    key: "SZ",
    value: "Swaziland",
    Iso3: "SWZ",
    Unicode: "🇸🇿",
    Dial: "268",
    Currency: "SZL",
    Capital: "Mbabane",
    Continent: "AF"
  },
  {
    key: "SY",
    value: "Syria",
    Iso3: "SYR",
    Unicode: "🇸🇾",
    Dial: "963",
    Currency: "SYP",
    Capital: "Damascus",
    Continent: "AS"
  },
  {
    key: "SX",
    value: "Sint Maarten",
    Iso3: "SXM",
    Unicode: "🇸🇽",
    Dial: "599",
    Currency: "ANG",
    Capital: "Philipsburg",
    Continent: "NA"
  },
  {
    key: "KG",
    value: "Kyrgyzstan",
    Iso3: "KGZ",
    Unicode: "🇰🇬",
    Dial: "996",
    Currency: "KGS",
    Capital: "Bishkek",
    Continent: "AS"
  },
  {
    key: "KE",
    value: "Kenya",
    Iso3: "KEN",
    Unicode: "🇰🇪",
    Dial: "254",
    Currency: "KES",
    Capital: "Nairobi",
    Continent: "AF"
  },
  {
    key: "SS",
    value: "South Sudan",
    Iso3: "SSD",
    Unicode: "🇸🇸",
    Dial: "211",
    Currency: "SSP",
    Capital: "Juba",
    Continent: "AF"
  },
  {
    key: "SR",
    value: "Surivalue",
    Iso3: "SUR",
    Unicode: "🇸🇷",
    Dial: "597",
    Currency: "SRD",
    Capital: "Paramaribo",
    Continent: "SA"
  },
  {
    key: "KI",
    value: "Kiribati",
    Iso3: "KIR",
    Unicode: "🇰🇮",
    Dial: "686",
    Currency: "AUD",
    Capital: "Tarawa",
    Continent: "OC"
  },
  {
    key: "KH",
    value: "Cambodia",
    Iso3: "KHM",
    Unicode: "🇰🇭",
    Dial: "855",
    Currency: "KHR",
    Capital: "Phnom Penh",
    Continent: "AS"
  },
  {
    key: "KN",
    value: "Saint Kitts and Nevis",
    Iso3: "KNA",
    Unicode: "🇰🇳",
    Dial: "+1-869",
    Currency: "XCD",
    Capital: "Basseterre",
    Continent: "NA"
  },
  {
    key: "KM",
    value: "Comoros",
    Iso3: "COM",
    Unicode: "🇰🇲",
    Dial: "269",
    Currency: "KMF",
    Capital: "Moroni",
    Continent: "AF"
  },
  {
    key: "ST",
    value: "Sao Tome and Principe",
    Iso3: "STP",
    Unicode: "🇸🇹",
    Dial: "239",
    Currency: "STD",
    Capital: "Sao Tome",
    Continent: "AF"
  },
  {
    key: "SK",
    value: "Slovakia",
    Iso3: "SVK",
    Unicode: "🇸🇰",
    Dial: "421",
    Currency: "EUR",
    Capital: "Bratislava",
    Continent: "EU"
  },
  {
    key: "KR",
    value: "South Korea",
    Iso3: "KOR",
    Unicode: "🇰🇷",
    Dial: "82",
    Currency: "KRW",
    Capital: "Seoul",
    Continent: "AS"
  },
  {
    key: "SI",
    value: "Slovenia",
    Iso3: "SVN",
    Unicode: "🇸🇮",
    Dial: "386",
    Currency: "EUR",
    Capital: "Ljubljana",
    Continent: "EU"
  },
  {
    key: "KP",
    value: "North Korea",
    Iso3: "PRK",
    Unicode: "🇰🇵",
    Dial: "850",
    Currency: "KPW",
    Capital: "Pyongyang",
    Continent: "AS"
  },
  {
    key: "KW",
    value: "Kuwait",
    Iso3: "KWT",
    Unicode: "🇰🇼",
    Dial: "965",
    Currency: "KWD",
    Capital: "Kuwait City",
    Continent: "AS"
  },
  {
    key: "SN",
    value: "Senegal",
    Iso3: "SEN",
    Unicode: "🇸🇳",
    Dial: "221",
    Currency: "XOF",
    Capital: "Dakar",
    Continent: "AF"
  },
  {
    key: "SM",
    value: "San Marino",
    Iso3: "SMR",
    Unicode: "🇸🇲",
    Dial: "378",
    Currency: "EUR",
    Capital: "San Marino",
    Continent: "EU"
  },
  {
    key: "SL",
    value: "Sierra Leone",
    Iso3: "SLE",
    Unicode: "🇸🇱",
    Dial: "232",
    Currency: "SLL",
    Capital: "Freetown",
    Continent: "AF"
  },
  {
    key: "SC",
    value: "Seychelles",
    Iso3: "SYC",
    Unicode: "🇸🇨",
    Dial: "248",
    Currency: "SCR",
    Capital: "Victoria",
    Continent: "AF"
  },
  {
    key: "KZ",
    value: "Kazakhstan",
    Iso3: "KAZ",
    Unicode: "🇰🇿",
    Dial: "7",
    Currency: "KZT",
    Capital: "Astana",
    Continent: "AS"
  },
  {
    key: "KY",
    value: "Cayman Islands",
    Iso3: "CYM",
    Unicode: "🇰🇾",
    Dial: "+1-345",
    Currency: "KYD",
    Capital: "George Town",
    Continent: "NA"
  },
  {
    key: "SG",
    value: "Singapore",
    Iso3: "SGP",
    Unicode: "🇸🇬",
    Dial: "65",
    Currency: "SGD",
    Capital: "Singapur",
    Continent: "AS"
  },
  {
    key: "SE",
    value: "Sweden",
    Iso3: "SWE",
    Unicode: "🇸🇪",
    Dial: "46",
    Currency: "SEK",
    Capital: "Stockholm",
    Continent: "EU"
  },
  {
    key: "SD",
    value: "Sudan",
    Iso3: "SDN",
    Unicode: "🇸🇩",
    Dial: "249",
    Currency: "SDG",
    Capital: "Khartoum",
    Continent: "AF"
  },
  {
    key: "DO",
    value: "Dominican Republic",
    Iso3: "DOM",
    Unicode: "🇩🇴",
    Dial: "+1-809 and 1-829",
    Currency: "DOP",
    Capital: "Santo Domingo",
    Continent: "NA"
  },
  {
    key: "DM",
    value: "Dominica",
    Iso3: "DMA",
    Unicode: "🇩🇲",
    Dial: "+1-767",
    Currency: "XCD",
    Capital: "Roseau",
    Continent: "NA"
  },
  {
    key: "DJ",
    value: "Djibouti",
    Iso3: "DJI",
    Unicode: "🇩🇯",
    Dial: "253",
    Currency: "DJF",
    Capital: "Djibouti",
    Continent: "AF"
  },
  {
    key: "DK",
    value: "Denmark",
    Iso3: "DNK",
    Unicode: "🇩🇰",
    Dial: "45",
    Currency: "DKK",
    Capital: "Copenhagen",
    Continent: "EU"
  },
  {
    key: "VG",
    value: "British Virgin Islands",
    Iso3: "VGB",
    Unicode: "🇻🇬",
    Dial: "+1-284",
    Currency: "USD",
    Capital: "Road Town",
    Continent: "NA"
  },
  {
    key: "DE",
    value: "Germany",
    Iso3: "DEU",
    Unicode: "🇩🇪",
    Dial: "49",
    Currency: "EUR",
    Capital: "Berlin",
    Continent: "EU"
  },
  {
    key: "YE",
    value: "Yemen",
    Iso3: "YEM",
    Unicode: "🇾🇪",
    Dial: "967",
    Currency: "YER",
    Capital: "Sanaa",
    Continent: "AS"
  },
  {
    key: "DZ",
    value: "Algeria",
    Iso3: "DZA",
    Unicode: "🇩🇿",
    Dial: "213",
    Currency: "DZD",
    Capital: "Algiers",
    Continent: "AF"
  },
  {
    key: "US",
    value: "United States",
    Iso3: "USA",
    Unicode: "🇺🇸",
    Dial: "1",
    Currency: "USD",
    Capital: "Washington",
    Continent: "NA"
  },
  {
    key: "UY",
    value: "Uruguay",
    Iso3: "URY",
    Unicode: "🇺🇾",
    Dial: "598",
    Currency: "UYU",
    Capital: "Montevideo",
    Continent: "SA"
  },
  {
    key: "YT",
    value: "Mayotte",
    Iso3: "MYT",
    Unicode: "🇾🇹",
    Dial: "262",
    Currency: "EUR",
    Capital: "Mamoudzou",
    Continent: "AF"
  },
  {
    key: "UM",
    value: "United States Minor Outlying Islands",
    Iso3: "UMI",
    Unicode: "🇺🇲",
    Dial: "1",
    Currency: "USD",
    Capital: "",
    Continent: "OC"
  },
  {
    key: "LB",
    value: "Lebanon",
    Iso3: "LBN",
    Unicode: "🇱🇧",
    Dial: "961",
    Currency: "LBP",
    Capital: "Beirut",
    Continent: "AS"
  },
  {
    key: "LC",
    value: "Saint Lucia",
    Iso3: "LCA",
    Unicode: "🇱🇨",
    Dial: "+1-758",
    Currency: "XCD",
    Capital: "Castries",
    Continent: "NA"
  },
  {
    key: "LA",
    value: "Laos",
    Iso3: "LAO",
    Unicode: "🇱🇦",
    Dial: "856",
    Currency: "LAK",
    Capital: "Vientiane",
    Continent: "AS"
  },
  {
    key: "TV",
    value: "Tuvalu",
    Iso3: "TUV",
    Unicode: "🇹🇻",
    Dial: "688",
    Currency: "AUD",
    Capital: "Funafuti",
    Continent: "OC"
  },
  {
    key: "TW",
    value: "Taiwan",
    Iso3: "TWN",
    Unicode: "🇹🇼",
    Dial: "886",
    Currency: "TWD",
    Capital: "Taipei",
    Continent: "AS"
  },
  {
    key: "TT",
    value: "Trinidad and Tobago",
    Iso3: "TTO",
    Unicode: "🇹🇹",
    Dial: "+1-868",
    Currency: "TTD",
    Capital: "Port of Spain",
    Continent: "NA"
  },
  {
    key: "TR",
    value: "Turkey",
    Iso3: "TUR",
    Unicode: "🇹🇷",
    Dial: "90",
    Currency: "TRY",
    Capital: "Ankara",
    Continent: "AS"
  },
  {
    key: "LK",
    value: "Sri Lanka",
    Iso3: "LKA",
    Unicode: "🇱🇰",
    Dial: "94",
    Currency: "LKR",
    Capital: "Colombo",
    Continent: "AS"
  },
  {
    key: "LI",
    value: "Liechtenstein",
    Iso3: "LIE",
    Unicode: "🇱🇮",
    Dial: "423",
    Currency: "CHF",
    Capital: "Vaduz",
    Continent: "EU"
  },
  {
    key: "LV",
    value: "Latvia",
    Iso3: "LVA",
    Unicode: "🇱🇻",
    Dial: "371",
    Currency: "EUR",
    Capital: "Riga",
    Continent: "EU"
  },
  {
    key: "TO",
    value: "Tonga",
    Iso3: "TON",
    Unicode: "🇹🇴",
    Dial: "676",
    Currency: "TOP",
    Capital: "Nuku'alofa",
    Continent: "OC"
  },
  {
    key: "LT",
    value: "Lithuania",
    Iso3: "LTU",
    Unicode: "🇱🇹",
    Dial: "370",
    Currency: "LTL",
    Capital: "Vilnius",
    Continent: "EU"
  },
  {
    key: "LU",
    value: "Luxembourg",
    Iso3: "LUX",
    Unicode: "🇱🇺",
    Dial: "352",
    Currency: "EUR",
    Capital: "Luxembourg",
    Continent: "EU"
  },
  {
    key: "LR",
    value: "Liberia",
    Iso3: "LBR",
    Unicode: "🇱🇷",
    Dial: "231",
    Currency: "LRD",
    Capital: "Monrovia",
    Continent: "AF"
  },
  {
    key: "LS",
    value: "Lesotho",
    Iso3: "LSO",
    Unicode: "🇱🇸",
    Dial: "266",
    Currency: "LSL",
    Capital: "Maseru",
    Continent: "AF"
  },
  {
    key: "TH",
    value: "Thailand",
    Iso3: "THA",
    Unicode: "🇹🇭",
    Dial: "66",
    Currency: "THB",
    Capital: "Bangkok",
    Continent: "AS"
  },
  {
    key: "TF",
    value: "French Southern Territories",
    Iso3: "ATF",
    Unicode: "🇹🇫",
    Dial: "",
    Currency: "EUR",
    Capital: "Port-aux-Francais",
    Continent: "AN"
  },
  {
    key: "TG",
    value: "Togo",
    Iso3: "TGO",
    Unicode: "🇹🇬",
    Dial: "228",
    Currency: "XOF",
    Capital: "Lome",
    Continent: "AF"
  },
  {
    key: "TD",
    value: "Chad",
    Iso3: "TCD",
    Unicode: "🇹🇩",
    Dial: "235",
    Currency: "XAF",
    Capital: "N'Djamena",
    Continent: "AF"
  },
  {
    key: "TC",
    value: "Turks and Caicos Islands",
    Iso3: "TCA",
    Unicode: "🇹🇨",
    Dial: "+1-649",
    Currency: "USD",
    Capital: "Cockburn Town",
    Continent: "NA"
  },
  {
    key: "LY",
    value: "Libya",
    Iso3: "LBY",
    Unicode: "🇱🇾",
    Dial: "218",
    Currency: "LYD",
    Capital: "Tripolis",
    Continent: "AF"
  },
  {
    key: "VA",
    value: "Vatican",
    Iso3: "VAT",
    Unicode: "🇻🇦",
    Dial: "379",
    Currency: "EUR",
    Capital: "Vatican City",
    Continent: "EU"
  },
  {
    key: "VC",
    value: "Saint Vincent and the Grenadines",
    Iso3: "VCT",
    Unicode: "🇻🇨",
    Dial: "+1-784",
    Currency: "XCD",
    Capital: "Kingstown",
    Continent: "NA"
  },
  {
    key: "AE",
    value: "United Arab Emirates",
    Iso3: "ARE",
    Unicode: "🇦🇪",
    Dial: "971",
    Currency: "AED",
    Capital: "Abu Dhabi",
    Continent: "AS"
  },
  {
    key: "AD",
    value: "Andorra",
    Iso3: "AND",
    Unicode: "🇦🇩",
    Dial: "376",
    Currency: "EUR",
    Capital: "Andorra la Vella",
    Continent: "EU"
  },
  {
    key: "AG",
    value: "Antigua and Barbuda",
    Iso3: "ATG",
    Unicode: "🇦🇬",
    Dial: "+1-268",
    Currency: "XCD",
    Capital: "St. John's",
    Continent: "NA"
  },
  {
    key: "AF",
    value: "Afghanistan",
    Iso3: "AFG",
    Unicode: "🇦🇫",
    Dial: "93",
    Currency: "AFN",
    Capital: "Kabul",
    Continent: "AS"
  },
  {
    key: "AI",
    value: "Anguilla",
    Iso3: "AIA",
    Unicode: "🇦🇮",
    Dial: "+1-264",
    Currency: "XCD",
    Capital: "The Valley",
    Continent: "NA"
  },
  {
    key: "VI",
    value: "U.S. Virgin Islands",
    Iso3: "VIR",
    Unicode: "🇻🇮",
    Dial: "+1-340",
    Currency: "USD",
    Capital: "Charlotte Amalie",
    Continent: "NA"
  },
  {
    key: "IS",
    value: "Iceland",
    Iso3: "ISL",
    Unicode: "🇮🇸",
    Dial: "354",
    Currency: "ISK",
    Capital: "Reykjavik",
    Continent: "EU"
  },
  {
    key: "IR",
    value: "Iran",
    Iso3: "IRN",
    Unicode: "🇮🇷",
    Dial: "98",
    Currency: "IRR",
    Capital: "Tehran",
    Continent: "AS"
  },
  {
    key: "AM",
    value: "Armenia",
    Iso3: "ARM",
    Unicode: "🇦🇲",
    Dial: "374",
    Currency: "AMD",
    Capital: "Yerevan",
    Continent: "AS"
  },
  {
    key: "AL",
    value: "Albania",
    Iso3: "ALB",
    Unicode: "🇦🇱",
    Dial: "355",
    Currency: "ALL",
    Capital: "Tirana",
    Continent: "EU"
  },
  {
    key: "AO",
    value: "Angola",
    Iso3: "AGO",
    Unicode: "🇦🇴",
    Dial: "244",
    Currency: "AOA",
    Capital: "Luanda",
    Continent: "AF"
  },
  {
    key: "AQ",
    value: "Antarctica",
    Iso3: "ATA",
    Unicode: "🇦🇶",
    Dial: "",
    Currency: "",
    Capital: "",
    Continent: "AN"
  },
  {
    key: "AS",
    value: "American Samoa",
    Iso3: "ASM",
    Unicode: "🇦🇸",
    Dial: "+1-684",
    Currency: "USD",
    Capital: "Pago Pago",
    Continent: "OC"
  },
  {
    key: "AR",
    value: "Argentina",
    Iso3: "ARG",
    Unicode: "🇦🇷",
    Dial: "54",
    Currency: "ARS",
    Capital: "Buenos Aires",
    Continent: "SA"
  },
  {
    key: "AU",
    value: "Australia",
    Iso3: "AUS",
    Unicode: "🇦🇺",
    Dial: "61",
    Currency: "AUD",
    Capital: "Canberra",
    Continent: "OC"
  },
  {
    key: "AT",
    value: "Austria",
    Iso3: "AUT",
    Unicode: "🇦🇹",
    Dial: "43",
    Currency: "EUR",
    Capital: "Vienna",
    Continent: "EU"
  },
  {
    key: "AW",
    value: "Aruba",
    Iso3: "ABW",
    Unicode: "🇦🇼",
    Dial: "297",
    Currency: "AWG",
    Capital: "Oranjestad",
    Continent: "NA"
  },
  {
    key: "IN",
    value: "India",
    Iso3: "IND",
    Unicode: "🇮🇳",
    Dial: "91",
    Currency: "INR",
    Capital: "New Delhi",
    Continent: "AS"
  },
  {
    key: "AX",
    value: "Aland Islands",
    Iso3: "ALA",
    Unicode: "🇦🇽",
    Dial: "+358-18",
    Currency: "EUR",
    Capital: "Mariehamn",
    Continent: "EU"
  },
  {
    key: "AZ",
    value: "Azerbaijan",
    Iso3: "AZE",
    Unicode: "🇦🇿",
    Dial: "994",
    Currency: "AZN",
    Capital: "Baku",
    Continent: "AS"
  },
  {
    key: "IE",
    value: "Ireland",
    Iso3: "IRL",
    Unicode: "🇮🇪",
    Dial: "353",
    Currency: "EUR",
    Capital: "Dublin",
    Continent: "EU"
  },
  {
    key: "ID",
    value: "Indonesia",
    Iso3: "IDN",
    Unicode: "🇮🇩",
    Dial: "62",
    Currency: "IDR",
    Capital: "Jakarta",
    Continent: "AS"
  },
  {
    key: "UA",
    value: "Ukraine",
    Iso3: "UKR",
    Unicode: "🇺🇦",
    Dial: "380",
    Currency: "UAH",
    Capital: "Kiev",
    Continent: "EU"
  },
  {
    key: "QA",
    value: "Qatar",
    Iso3: "QAT",
    Unicode: "🇶🇦",
    Dial: "974",
    Currency: "QAR",
    Capital: "Doha",
    Continent: "AS"
  },
  {
    key: "MZ",
    value: "Mozambique",
    Iso3: "MOZ",
    Unicode: "🇲🇿",
    Dial: "258",
    Currency: "MZN",
    Capital: "Maputo",
    Continent: "AF"
  }
];

export default country;
